import { render, staticRenderFns } from "./healthCardSetDetail.vue?vue&type=template&id=579f6159&scoped=true"
import script from "./healthCardSetDetail.vue?vue&type=script&lang=js"
export * from "./healthCardSetDetail.vue?vue&type=script&lang=js"
import style0 from "./healthCardSetDetail.vue?vue&type=style&index=0&id=579f6159&prod&lang=scss&scoped=true"
import style1 from "./healthCardSetDetail.vue?vue&type=style&index=1&id=579f6159&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579f6159",
  null
  
)

export default component.exports